<template>
  <div id="nav-menu-btn" 
    class="nav-menu-btn" 
    :class="{ 'open' : $root.menuOpen, 'dark': $root.theme == 'dark' }"
    @click="$root.menuToggle()"
  >
    <span></span>
  </div>
</template>
